export const PRO_CONFIG = {
	appheaders: {'appid': 'IF03-0618', 'apptoken': '$2a$06$mSyU0gsqkhuzOYdaTsLvkuyUPiRL6alpw2sqXmzE6ISdIoupAnz16'}, // 请求头headers
	Homeapi: 'https://api.fcsc.com/toplistService',
	serviceName: '龙虎榜',
	serviceId: 'ZFT_TOPLIST',
	Vconsole: false,
	aplus: 'track.fcsc.com', // 阿里云埋点配置
	appKey: '50tf4oww10lsqfag436rpw9l', // 阿里云埋点配置
	reqxml: 'https://h5hqservice.95358.com:8443'
}


// WEBPACK FOOTER //
// ./src/api/config_master.js